<template>
  <v-hover @input="setIsCardHovered($event)">
    <router-link
      :to="{
        name: $router.currentRoute.name,
        query: {
          ...$route.query,
          destinationId: properties.destinationId
        }
      }"
    >
      <v-card class="rounded-4 relative" width="230px" style="overflow:hidden">
        <!-- IMAGE -->
        <BaseSheet color="grey lighten-2">
          <v-img :src="destinationPicture" height="130px" width="230px">
          </v-img>
        </BaseSheet>
        <div
          class="px-4 py-4 d-flex flex-wrap flex-column justify-space-between"
        >
          <!-- Card Header -->
          <div class="d-flex align-start justify-start">
            <v-icon
              color="primary"
              size="24"
              class="mr-2 flex-shrink-0 align-self-start"
            >
              {{ `$${properties.category}` }}
            </v-icon>
            <span class="text-h6 word-break-break-word">
              {{ properties.shortName | firstLetterUppercase }}
            </span>
          </div>
          <!-- due to properties stringification from mapbox, has to check if distance is a string different of null -->
          <SearchDestinationCardDistanceInformation
            v-if="
              searchParams.shortName != properties.shortName &&
                properties.distance !== 'null'
            "
            :distance="properties.distance"
            :routeUrl="properties.routeUrl"
            :searchPlaceType="searchParams.placeType"
            :searchShortName="searchParams.shortName"
            class="pb-0 pl-0"
          ></SearchDestinationCardDistanceInformation>
        </div>
      </v-card>
    </router-link>
  </v-hover>
</template>
<script>
import SearchDestinationCardDistanceInformation from "../SearchDestinationCardDistanceInformation.vue";
// Instance used in MapServicePopUp
export default {
  name: "TheMapHoverPopup",
  components: {
    SearchDestinationCardDistanceInformation
  },
  // DATAs
  props: {
    properties: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isCardHovered: false
    };
  },
  computed: {
    // Because MAPBOX stringify data from destination layers
    mainPicture() {
      return JSON.parse(this.properties.mainPicture);
    },
    destinationPicture() {
      if (this.mainPicture)
        return this.$vuetify.breakpoint.xs
          ? this.mainPicture.small
          : this.mainPicture.medium;
      return require("@/assets/defaultCardPicture.png");
    },
    searchParams() {
      return this.$store.state.search.searchParams;
    }
  },
  // METHODs
  methods: {
    setIsCardHovered(event) {
      this.isCardHovered = event;
    },
    getFontSizeClass(length) {
      switch (true) {
        case length < 15:
          return "text-h3";
        case length < 20:
          return "text-h4";
        case length < 30:
          return "text-h5";
        default:
          return "text-h5";
      }
    }
  },
  watch: {
    isCardHovered(value) {
      value
        ? this.$store.dispatch("search/setCloseHoverPopUpToFalse")
        : this.$store.dispatch("search/setCloseHoverPopUpToTrue");
    }
  }
};
</script>
